import { Module } from 'vuex'
import { isEmpty, orderBy } from 'lodash'
import useragent from '@finance/useragent'
import {
  fetchAccounts,
  prePaid,
  fetchUserType,
  fetchPlan,
  queryPrepaidPlans,
  payNeedMin,
  fetchAccountBooks
} from '$services/account'
import { rechargePackages } from '$utils/common'

interface AccountState {
  accounts: any[]
  prePaidResult: any
  userType: any
  plan: any
  currentBook: any,
  prepaidPlans: any[],
  payRange: any
  books: any[]
}

const account: Module<AccountState, any> = {
  namespaced: true,
  state: {
    accounts: [],
    prePaidResult: {},
    userType: null,
    plan: {},
    currentBook: {
      book_name: '未选中神象云账本',
      book_id: ''
    },
    prepaidPlans: rechargePackages,
    payRange: {
      total_pay_amount: 0
    },
    books: []
  },
  getters: {
    currentAccount(state) {
      if (isEmpty(state.accounts)) {
        return {
          balance_available: 0
        }
      } else {
        return state.accounts[0]
      }
    }
  },
  mutations: {
    updateAccounts(state, data) {
      state.accounts = data
    },
    updatePrePaidResult(state, data) {
      state.prePaidResult = data
    },
    updateUserType(state, data) {
      state.userType = data
    },
    updatePlan(state, data) {
      state.plan = data
    },
    updateCurrentBook(state, data) {
      state.currentBook = data
    },
    updatePrepaidPlans(state, data) {
      state.prepaidPlans = data
    },
    updatePayRange(state, data) {
      state.payRange = data
    },
    updateBooks(state, data) {
      state.books = data
    }
  },
  actions: {
    async queryPrepaidPlans({ commit }) {
      let res = await queryPrepaidPlans()
      res = rechargePackages.map((el: any) => {
        const plan: any = res.find((it: any) => parseInt(it.plan_type, 10) === el.planType)
        return {
          ...plan,
          ...el,
          realPrice: plan.plan_price
        }
      })
      commit('updatePrepaidPlans', res)
      return res
    },
    /**
     * 用户余额查询
     */
    async fetchAccounts({ commit }, payload) {
      const res = await fetchAccounts(payload)
      if (isEmpty(res)) {
        commit('updateAccounts', [{ balance_available: 0 }])
      } else {
        commit('updateAccounts', res)
      }
      return res
    },
    /**
     * 用户预购买操作支付
     */
    async prePaid({ commit, state }, payload) {
      const res = await prePaid(payload)
      if (isEmpty(res)) {
        commit('updatePrePaidResult', {})
      } else {
        commit('updatePrePaidResult', res)
      }
      return state.prePaidResult
    },
    /**
     * 查询用户类型：1 主人 2 管理员 3 成员
     */
    async fetchUserType({ commit, state }) {
      const { user_type: userType } = await fetchUserType()
      if (isEmpty(userType)) {
        commit('updateUserType', null)
      } else {
        commit('updateUserType', userType)
      }
      return state.userType
    },
    /**
     * 查询账本下购买的服务套餐
     */
    async fetchPlan({ commit }) {
      try {
        const res = await fetchPlan()
        if (res.book_id) {
          commit('updatePlan', res)
        } else {
          commit('updatePlan', {})
        }
      } catch (err) {
        console.log(err)
        commit('updatePlan', {})
      }
    },
    /**
     * 查询最小档位
     */
    async queryPayRange({ commit }, value: number) {
      const WECHATH5PAY = 1
      const APPLEPAY = 2
      // pay_type 1:微信支付 2:苹果支付,3:支付宝支付,4:华为支付 6:小程序支付
      const res = await payNeedMin({
        pay_type: useragent.isIOS ? APPLEPAY : WECHATH5PAY,
        product_name: 'MyMoney',
        need_count: value
      })
      commit('updatePayRange', res)
      return res
    },
    /**
     * 查询用户账本列表
     */
    async queryAccountBooks({ commit }) {
      let bookList = await fetchAccountBooks()
      if (bookList && bookList.length > 0) {
        bookList = bookList.map((el: any) => {
          return {
            ...el,
            account_balance: el.account_balance * 1,
            last_open_time: el.last_open_time * 1,
          }
        })
        bookList = orderBy(bookList, ['account_balance', 'last_open_time'], ['desc', 'desc'])
        commit('updateBooks', bookList)
      }
      return bookList
    }
  }
}

export default account
